import script from "./Buildings.vue?vue&type=script&setup=true&lang=js"
export * from "./Buildings.vue?vue&type=script&setup=true&lang=js"

import "./Buildings.vue?vue&type=style&index=0&id=0f373caa&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f373caa"]])

export default __exports__